module.exports = __webpack_public_path__ + "img/sort-item.95e23e8b.svg";